import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} fill="#fff" />
            <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} stroke={theme["#0EA59D"]} />
            <path
                d="M14.208 17.46L12.666 19a.837.837 0 01-1.175.009c-.092-.092-.183-.175-.275-.267a23.683 23.683 0 01-2.325-2.725c-.683-.95-1.233-1.9-1.633-2.842-.392-.95-.592-1.858-.592-2.725 0-.566.1-1.108.3-1.608.2-.508.517-.975.958-1.392.534-.525 1.117-.783 1.734-.783.233 0 .466.05.675.15.216.1.408.25.558.467l1.933 2.725c.15.208.259.4.334.583.075.175.116.35.116.508 0 .2-.058.4-.175.592a2.834 2.834 0 01-.466.592l-.634.658a.446.446 0 00-.133.333c0 .067.008.125.025.192.025.067.05.117.067.167.15.275.408.633.775 1.066.375.434.775.875 1.208 1.317.083.083.175.167.258.25a.835.835 0 01.009 1.192z"
                fill={theme["#0EA59D"]}
            />
            <path
                d="M23.308 20.275c0 .233-.042.475-.125.708-.025.067-.05.134-.083.2-.142.3-.325.584-.567.85-.408.45-.858.775-1.367.984-.008 0-.016.008-.025.008a4.21 4.21 0 01-1.6.308c-.85 0-1.758-.2-2.716-.608a14.634 14.634 0 01-2.867-1.65c-.325-.242-2.146-1.797-2.454-2.055l2.662-2.77c.234.175 2 1.667 2.175 1.758.042.017.092.042.15.067a.575.575 0 00.209.033c.141 0 .25-.05.341-.141l.634-.625a2.56 2.56 0 01.6-.467 1.11 1.11 0 01.591-.175c.159 0 .325.033.509.108.183.075.375.184.583.325l2.758 1.959c.217.15.367.325.459.533.083.208.133.417.133.65z"
                fill={theme["#0EA59D"]}
            />
        </svg>
    )
}
  
  export default SvgComponent